import { Injectable } from '@angular/core';
import { OFFICE, TEAM, VerticalType } from '@rma/generic/domain/types';
import { PagedList } from '@rma/public/generic/domain/types';
import { LocationProfileFacade } from '@rma/public/locations/private/orc-profile-page';
import { mapLocationProfile } from '@rma/public/locations/private/ui-profile-cards';
import {
  LocationDetails,
  LocationGroupFilter,
  LocationProfile,
  RankingStatisticType,
} from '@rma/public/locations/public/api-location-details';
import { map, Observable, switchMap, take, withLatestFrom } from 'rxjs';

@Injectable()
export class LocationGroupsFacade extends LocationProfileFacade {
  public override getLocationProfiles(
    page: number,
    statisticType: RankingStatisticType,
    location: LocationDetails,
    verticalType: VerticalType,
  ): Observable<PagedList<LocationProfile>> {
    const amount = 9;

    return this.tabType$.pipe(
      take(1),
      switchMap((tab) => {
        const profileType = tab === 'Teams' ? TEAM : OFFICE;

        const filter: LocationGroupFilter = {
          includeAll: true,
          take: amount,
          skip: (page - 1) * amount,
          statisticType,
          profileType,
        };

        return this.locationApiService
          .getLocationGroupProfiles(verticalType, location.locationType, location.locationId, profileType, filter)
          .pipe(
            withLatestFrom(this.hideDaysOnMarket$),
            map(
              ([groups, hideDaysOnMarket]): PagedList<LocationProfile> => ({
                ...groups,
                results: groups.results?.map((r) => mapLocationProfile(r, location, verticalType, hideDaysOnMarket)) ?? [],
              }),
            ),
          );
      }),
    );
  }
}
